import ls from "localstorage-slim";

export default async function () {
  ls.flush();
}
